module.exports = __webpack_public_path__ + "img/Yellow-Ladyslipper-Orchid.1700c657.jpg";